module.exports = __webpack_public_path__ + "img/edit.7b372e25.svg";